var chunkMapping = {
	"5110": [
		"webpack/container/remote/feed/Feed"
	],
	"7496": [
		"webpack/container/remote/activities/Activities"
	],
	"8482": [
		"webpack/container/remote/survey/Survey"
	],
	"8820": [
		"webpack/container/remote/application/Application"
	],
	"9810": [
		"webpack/container/remote/survey/GlobalSurveyModal"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/activities/Activities": [
		"default",
		"./Activities",
		"webpack/container/reference/activities"
	],
	"webpack/container/remote/feed/Feed": [
		"default",
		"./Feed",
		"webpack/container/reference/feed"
	],
	"webpack/container/remote/application/Application": [
		"default",
		"./Application",
		"webpack/container/reference/application"
	],
	"webpack/container/remote/survey/Survey": [
		"default",
		"./Survey",
		"webpack/container/reference/survey"
	],
	"webpack/container/remote/survey/GlobalSurveyModal": [
		"default",
		"./GlobalSurveyModal",
		"webpack/container/reference/survey"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}